module.exports = __webpack_public_path__ + "img/avatar-05-140x140.d4a5d95c.png";